<template>
  <div id="app">
    <a class="kt-skip-link" href="#main-content">
      Skip to content
    </a>
    <nav v-if="$route.name !== 'Colors'" class="uk-navbar-container" uk-navbar>
      <div class="uk-navbar-left">
        <a class="uk-navbar-item uk-logo" href="https://knottytie.com">
          <img
            v-if="!distributorLogo"
            src="./assets/logo/knotty-logo-small.png"
            alt="Knotty Tie"
            style="height: 50px"
          />
          <img
            v-if="distributorLogo"
            src="./assets/KnottyPromo-01.png"
            alt="Knotty Promo"
            style="height: 50px"
          />
        </a>
      </div>

      <div class="uk-navbar-right">
        <ul class="uk-navbar-nav">
          <li v-if="showProjectsLink">
            <router-link to="/projects">My Projects</router-link>
          </li>
          <li>
            <a href="#">Help</a>
            <div class="uk-navbar-dropdown">
              <ul class="uk-nav uk-navbar-dropdown-nav">
                <li>
                  <a href="#" @click="intercomShow">Chat</a>
                </li>
                <li>
                  Email:
                  <a href="mailto:team@knottytie.com">team@knottytie.com</a>
                </li>
                <li>
                  <a
                    href="https://www.knottytie.com/pages/frequently-asked-questions"
                    target="_blank"
                  >
                    FAQs
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </nav>
    <main id="main-content" tabindex="-1">
      <router-view @project="setProject" />
    </main>
  </div>
</template>

<script>
import UIkit from "uikit/dist/js/uikit";
import Icons from "uikit/dist/js/uikit-icons";
import LogRocket from "logrocket";

UIkit.use(Icons);
export default {
  name: "App",
  data() {
    return {
      project: {}
    };
  },
  computed: {
    showProjectsLink() {
      if (
        this.$route.path.includes("project") &&
        !this.$route.path.includes("admin") &&
        !this.$route.path.includes("new-project")
      ) {
        return true;
      }
    },
    distributorLogo() {
      if (this.project.type == "Distributor") {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    window.Intercom("boot", {
      app_id: "iabt02ig"
    });

    (function(h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function() {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: 1372555, hjsv: 6 };
      a = o.getElementsByTagName("head")[0];
      r = o.createElement("script");
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");

    LogRocket.init("ojm24v/onboarding");
  },
  methods: {
    intercomShow() {
      Intercom("show");
    },
    setProject(project) {
      this.project = project;
    }
  }
};
</script>

<style lang="less">
@import "./assets/theme/theme.less";

.kt-skip-link {
  position: absolute;
  left: -9999px;
  top: 0;
  z-index: 1000;
  background: #fff;
  color: #333;
  padding: 10px 16px;

  &:focus {
    left: 0;
  }
}

#main-content:focus {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue